import React, { useState } from "react";
// import { Transition } from "@headlessui/react";
// import { Link, useLocation } from "react-router-dom";

import logo from "../assets/img/logo1.svg";
import logoHover from "../assets/img/hoverlogo1.svg";

function Navbar() {
  const [hover, setHover] = useState(false);
  return (
    <nav className="z-10 fixed top-0 w-full md:w-[90vw] text-white flex flex-row justify-between items-center px-7 md:pl-20 py-[20px]">
      <a
        href="/"
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
      >
        <img
          src={hover ? logoHover : logo}
          alt="Nverse logo"
          className="h-[64px] object-contain"
        />
      </a>
      <hr className="w-[90%] ml-[2%]" />
    </nav>
  );
}

export default Navbar;
